// extracted by mini-css-extract-plugin
export default {"container":"MapControls_container__uNjf3","terrainOptions":"MapControls_terrainOptions__uf5u+","controls":"MapControls_controls__E2CI+"};